import { BaseModel } from '../base-model';

export interface IUserParameterModel {
  SiteId?: number;
}
export class UserParameterModel extends BaseModel<IUserParameterModel> implements IUserParameterModel {
  SiteId: number;
  /**
     *
     */
  constructor(option?: IUserParameterModel) {
    super(option);
  }
}

